import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-warning-message',
  templateUrl: './warning-message.component.html',
  styleUrls: ['./warning-message.component.scss'],
})
export class WarningMessageComponent implements OnInit {
  expanded: boolean = false;
  show: boolean = true;

  @Input()
  expandable?: boolean = false;

  constructor() { }

  ngOnInit() {}

  dismiss() {
    this.show = false;
  }

  toggleExpanded() {
    this.expanded = ! this.expanded;
  }

}
